import React from 'react';
import * as dates from '@simplybenefits/sb-dates';
import Text from './Text.js';
import { colors } from '../theme/index.js';
import { styled } from '@mui/system';
const StyledContainer = styled('div')(({
  theme
}) => ({
  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.15)',
  background: '#FFF',
  width: '254px',
  // 336,
  height: '240px',
  // 315,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  margin: '8px',
  position: 'relative',
  '&:hover': {
    boxShadow: '0px 12px 40px rgba(0, 0, 0, 0.15)'
  }
}));

/**
 * @param date
 * @param onClick
 * @param classes
 * @param id
 * @param testid
 * @param isFirstInvoice
 * @returns {*}
 * @constructor
 */
const MonthTile = ({
  date,
  onClick,
  status,
  id,
  testid,
  isFirstInvoice = false,
  whitelabel = {}
}) => /*#__PURE__*/React.createElement(StyledContainer, {
  id: id || testid,
  onClick: onClick
}, isFirstInvoice ? /*#__PURE__*/React.createElement(Text, {
  mediumLarge: true,
  display: "block",
  align: "center",
  marginBottom: 20
}, "Census Billing") : /*#__PURE__*/React.createElement(Text, {
  mediumLarge: true,
  display: "block",
  align: "center",
  marginBottom: 20
}, dates.getLocalDisplay(date, 'MMMM YYYY')), /*#__PURE__*/React.createElement(Text, {
  medium: true,
  color: status === 'Paid' ? colors.brandGreen : status === 'Failed' ? colors.red : whitelabel.primaryColor || colors.darkBlue,
  display: "block",
  align: "center",
  uppercase: true,
  bold: true
}, status === 'Pending' ? status : ''));
export default MonthTile;